<div class="w-full relative flex items-center flex-col justify-center" [ngClass]="screen ? 'h-screen w-screen' : 'not-found-height w-full'">
    <div class="absolute inset-0 flex items-center justify-center">
        <p style="font-size: 40rem; opacity: 0.1" class="font-bold">404</p>
    </div>
    <p class="text-4xl text-gray-700">{{ text }}</p>
</div>